/**
/View/Commerce/Checkout/CheckoutVatInfo.cshtml is the corresponding view file that uses this script.
**/

let $enableVatIdCheckbox;
let $issuingCountryDropdown;
let $vatInputBox;

const VIES_UNABLE_TO_VERIFY_CODE = 'vies_unable_to_verify';
const VIES_VAT_INVALID_CODE = 'vat_invalid';

function setVatControlsProps() {
    const isChecked = $enableVatIdCheckbox.is(':checked');

    $issuingCountryDropdown.prop('disabled', !isChecked);
    $issuingCountryDropdown.prop('required', isChecked);
    $vatInputBox.prop('disabled', !isChecked);
    $vatInputBox.prop('required', isChecked);
    let $issuingCountrySelectorBlock = $('.issuing-country-selector-block');
    if(isChecked) {
        $issuingCountrySelectorBlock.removeClass('disabled');
    } else {
        $issuingCountrySelectorBlock.addClass('disabled');
    }
    // set IsVIES property
    const selectedOption = selectedIssuingCountryOption();
    $('#isVIES').val(getIsViesPropValue(selectedOption));
}

function selectedIssuingCountryOption() {
    const selectedIndex = $issuingCountryDropdown.prop('selectedIndex');
    if(selectedIndex > 0) {
        let options = $issuingCountryDropdown.find('option');
        return options[selectedIndex];
    }
    return null;
}

function getTinPrefixPropValue(option) {
    return option == null ? '' : option.getAttribute('data-tin_prefix');
}

function getIsViesPropValue(option) {
    return option == null ? 'false' : option.getAttribute('data-is-vies');
}

function adjustVatInputValues() {
    const selectedCountryCode = $issuingCountryDropdown.val();
    $('#vatId').val(selectedCountryCode);

    const selectedOption = selectedIssuingCountryOption();

    // set tinPrefix to data-tin_prefix value from the selected option
    const tinPrefixPropValue = getTinPrefixPropValue(selectedOption);
    $vatInputBox.val(tinPrefixPropValue);

    // set IsVIES property
    $('#isVIES').val(getIsViesPropValue(selectedOption));
}

function watchStateChanges() {
    $enableVatIdCheckbox.on('change', function () {
        setVatControlsProps();
    });

    $issuingCountryDropdown.on('change', function () {
        adjustVatInputValues();
        $vatInputBox.focus();
    });
}

export function handleVIESErrorMessageIfAny(result) {
    if(result.Messages.length > 0) {
        let attemptsExceededMessage = result.Messages.find(msg => msg.Code === VIES_UNABLE_TO_VERIFY_CODE);
        if(attemptsExceededMessage) {
            $('#viesValidationAttemptsExceededMsg').text(attemptsExceededMessage.MessageText);
            $('[name="enableVatId"]')
                .prop('checked', false)
                .prop('disabled', true);
            $('#viesValidationAttemptsExceededMsg-container').show();
            lockDownVatInputs();
            return true; // meaning we handled it
        }
        let invalidVatMessage = result.Messages.find(msg => msg.Code === VIES_VAT_INVALID_CODE);
        if(invalidVatMessage) {
            $('#vat-error-container').addClass('is--error');
            $('#vat-error-msg').html(invalidVatMessage.MessageText);
            $('#vat-error-msg').show();
            return true; // meaning we handled it
        }
    }
    return false; // meaning we didn't handle it
}

function lockDownVatInputs() {
    $issuingCountryDropdown.prop('disabled', true);
    $vatInputBox.prop('disabled', true);
    $('.issuing-country-selector-block').addClass('disabled');
    $('label[for="enableVatId"]').addClass('disabled');
}

$(function () {
    $enableVatIdCheckbox = $('#enableVatId');
    var isVatAddedToCart = $('#isVatAddedToCart').html();
    if(isVatAddedToCart === 'True') {
        $enableVatIdCheckbox.prop('checked', true);
    }
    $issuingCountryDropdown = $('#issuingCountry');
    $vatInputBox = $('#vat');
    setVatControlsProps();
    watchStateChanges();
});
